import React, { useState, useRef, useEffect } from "react";

const Dropdown = ({
  label,
  options,
  onSelect,
  placeholder,
  preselectedValue,
  colorLabel,
  search,
  font,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    preselectedValue?.label || null
  );
  const [searchTerm, setSearchTerm] = useState(""); // State for search input
  const dropdownRef = useRef();

  const handleSelect = (option) => {
    setSelectedOption(options.length > 0 ? option.label : null);
    setIsOpen(false);
    onSelect(option);
  };

  useEffect(() => {
    if (preselectedValue) {
      setSelectedOption(preselectedValue.label);
    }
  }, [preselectedValue]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter options based on search term
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative" ref={dropdownRef}>
      {label && (
        <label
          className={`block w-full mb-2 text-sm whitespace-normal break-words ${
            colorLabel ? colorLabel : "text-[#464646]"
          }`}
        >
          {label}
        </label>
      )}

      <button
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
        className="relative w-full border font-medium border-gray-300 min-h-10 rounded-md text-sm px-2 pr-10 bg-white flex items-center text-left focus:outline-none"
      >
        <span
          className={`${
            font == "small"
              ? "text-[12px]"
              : "whitespace-normal pr-2 break-words"
          }  break-words`}
        >
          {selectedOption || placeholder}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-black pointer-events-none"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06-.02L10 10.69l3.71-3.5a.75.75 0 111.04 1.08l-4 3.75a.75.75 0 01-1.04 0l-4-3.75a.75.75 0 01-.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {isOpen && (
        <div
          className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-[9999]"
          style={{ maxHeight: "200px" }}
        >
          {/* Search Input */}
          {search && (
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 border-b focus:outline-none"
            />
          )}

          {/* Filtered Options */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => handleSelect(option)}
                className="px-4 py-2 hover:bg-black hover:text-white cursor-pointer"
              >
                {option.label}
              </div>
            ))
          ) : (
            <div className="px-4 py-2 text-gray-500">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
